<template>
	<div class="mainPage">
		 <div class="header_banner">
        <div class="imgBg">
          <img src="../img/chineseCultureVideoExhibition2025/new_2024/m_banner.png" alt="">
        </div>
        <!-- <header>
          <div class="center">
            <div class="right">
              <div v-if="!isLogin" class="loginCon">
                <span @click="toLogin()">{{ $t('message.login') }}</span> /
                <span @click="toLogin()">{{ $t('message.register') }}</span>
              </div>
              <div v-if="isLogin" class="loginCon">
                <span><span class="username">{{ user.username }}</span><span @click="toLogOut()">{{$t('message.logout') }}</span> </span>
              </div>
            </div>
          </div>
        </header> -->
        <div class="infoCon">
          <div class="centerBg">
            <img src="../img/chineseCultureVideoExhibition2025/new_2024/m_logo_title.png" alt="" class="left">
          </div>
        </div>
		</div>
    
		<div class="content">
			<div class="leftBox" @mousewheel.prevent>
				<div class="box" v-show="isShowGuide">
					<div class="titleBox" v-for="(item, index) in subject_info" :key="item.id" :class="{ active: active === index }"
						@click="getCollectInfo(item, index)">
						<div class="title">
							<span class="title_cn">{{ item.name }}</span>
							<span class="title_en">{{ item.name_en }}</span>
						</div>
					</div>
					<div class="icon" @click="showDirectory()">
						<img src="../img/chineseCultureVideoExhibition/m_icon2.png" alt="">
					</div>
				</div>
				<div class="icon1" v-show="!isShowGuide" @click="showDirectory()">
					<img src="../img/chineseCultureVideoExhibition/m_icon1.png" alt="">
				</div>
			</div>

      <div class="rightBox">
        <div class="back_arrow" @click="goBack()"> < </div>
        <div class="page_con">
          <div class="video_wrap">
            <div class="cover_con" v-if="!showVideo && videoInfo && videoInfo.cover_url" @click="showVideo = true">
              <img src="../img/chineseCultureVideoExhibition2025/play.png" alt="" class="play_icon">
              <img :src="videoInfo.cover_url" alt="" class="video_cover">
            </div>
            <div class="videoContainer" v-if="showVideo">
              <video
                :src="videoInfo.video_url"
                id="liveVideo"
                autoplay
                controls
                controlsList="nodownload"
              ></video>
            </div>
            <div class="video_list_wrap">
              <ul class="video_list" v-if="subjectDetail.type == 1">
                <li v-for="(v, i) in videoList" :key="i" @click="playVideo(i)">{{ i }}</li>
              </ul>
            </div>
            <div class="link" @click="goProgramLink()" v-if="subjectDetail.type == 1">
              <img src="../img/chineseCultureVideoExhibition2025/link.png" alt="" class="link_icon">
              <div class="name_con">
                <p class="cn">节目链接</p>
                <p class="en">Program link</p>
              </div>
            </div>
            <div class="link_con" v-if="subjectDetail.type == 2">
              <div class="link" @click="goProgramLink()" v-if="subjectDetail.internal_address">
                <img src="../img/chineseCultureVideoExhibition2025/link.png" alt="" class="link_icon">
                <div class="name_con">
                  <p class="cn">节目链接</p>
                  <p class="en">Program link</p>
                </div>
              </div>
              <div class="link" @click="goOverseasLink()" v-if="subjectDetail.external_address">
                <img src="../img/chineseCultureVideoExhibition2025/link.png" alt="" class="link_icon">
                <div class="name_con">
                  <p class="cn">外网链接</p>
                  <p class="en">Overseas Links</p>
                </div>
              </div>
            </div>
          </div>
          <div class="projectProfile detail">
            <div class="box">
              <div class="name_cn">{{subjectDetail.name}}</div>
              <div class="name_en">{{subjectDetail.name_en}}</div>
              <div class="text">
                {{subjectDetail.describe}}
              </div>
              <div class="text2">
                {{subjectDetail.describe_en}}
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div class="footer">
        <div class="copy">Copyright © ChinesePlus</div>
      </div>

		  <div id="menuGuide" v-show="isShowGuide" @click="showDirectory()"  @mousewheel.prevent></div> 
		</div>
</template>

<script>
import Qs from 'qs'
import language from './common/language'
export default {
	name: 'chinesebridge',
	components: {
		language
	},
  metaInfo() {
    return {
      title: "魅力中文，中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content:
            "魅力中文，中央广播电视总台精品节目展播",
        },
        {
          name: "description",
          content:
            "魅力中文，中央广播电视总台精品节目展播",
        },
      ],
    };
  },
	data: function () {
		return {
			isChrome: true,
			isLogin: false,
			isPlay: false,
			currentVideoUrl: '',
			user: {
				username: '',
				email: ''
			},
			lang: 'cn',
			isShowGuide: false,
			active: 0,
			subject_info: [],
			courseList: {},
			activeTab: 0,
			subject_id: null,
			subject_name: [],
			subject_subText: [],
      showDetail: false,
      videoList: [],
      showVideo: false,
      collection_id: '',
      videoIndex: '',
      subjectDetail: '',
      videoInfo: {
        cover_url: ''
      }
		}
	},
	computed: {
		language() {
			return this.$i18n.locale
		}
	},
  created() {
    this.collection_id = this.$route.query.collection_id
    this.videoIndex = this.$route.query.videoIndex
    
    this.getCollectList()
    this.getSubjectInfo()
    this.getVideoList()
  },
  mounted() {
    this.customCheckLogin();
    this.checkChrome();

    let activeTab = this.$route.query.tab;
    if (activeTab) {
      this.activeTab = activeTab;
    }
  },
  methods: {
    // 登录
    toLogin() {
      window.location.href =
        this.baseUrl +
        "user/api/login?" +
        "callback=" +
        encodeURIComponent(window.location.href);
    },
    // 注册
    toRegister() {
      window.location.href =
        "https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=" +
        encodeURIComponent(window.location.href);
    },
    // 检查是否登录 获取用户信息
    customCheckLogin() {
      this.checkLogin()
        .then((res) => {
          if (res.data.success) {
            this.isLogin = true;
            this.user = res.data.data;
          } else {
            this.isLogin = false;
          }
        })
        .catch((r) => {
          console.log(r);
        });
    },
    // 退出登录
    toLogOut() {
      this.$utils.get("/user/api/logout").then((res) => {
        if (res.data.success) {
          this.isLogin = false;
        }
      });
    },
    showDirectory() {
			this.isShowGuide = !this.isShowGuide
		},
    goBack () {
      this.$router.push({
        path: '/m_page/m_cmgp2025',
      })
    },
    goProgramLink () {
      window.open(this.subjectDetail.internal_address)
    },
    goOverseasLink () {
      window.open(this.subjectDetail.external_address)
    },
    getCollectInfo (item, index) {
      this.active = index
      this.$router.push({
        path: '/m_page/m_cmgp2025_detail',
        query: {
          collection_id: item.id,
          videoIndex: 0
        }
      })
      this.collection_id = this.$route.query.collection_id
      this.videoIndex = 0
      this.showVideo = false
      this.videoInfo = {}
      this.getSubjectInfo()
      this.getVideoList()
    },
    getCollectList () {
      this.$utils.get("/subject/lesson_Collection/getlist", {
        limit: 999,
        alias: '2025mlzw',
      })
      .then((res) => {
        if (res.data.success) {
          this.subject_info = res.data.data.list
          this.active = this.subject_info.findIndex((v)=> {
            return v.id == this.collection_id
          })
          // console.log(this.collection_id,this.active)
        }
      })
    },
    getVideoList() {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: this.collection_id,
          order: 'sort',
          limit: 30
        })
        .then((res) => {
          if (res.data.success) {
            this.videoList = res.data.data.list
            this.videoInfo = this.videoList[this.videoIndex]
          }
        })
    },
    getSubjectInfo() {
      this.$utils
        .get("/subject/lesson_Collection/read", {
          id: this.collection_id,
        })
        .then((res) => {
          if (res.data.success) {
            this.subjectDetail = res.data.data
          }
        })
    },
    playVideo (index) {
      this.showVideo = false
      this.videoInfo = this.videoList[index]
    },

    //排序
    compare(property) {
      return function(a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },

    //播放课程
    replay(url, cover) {
      // console.log(url)
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function() {
        //
        $("#liveVideo").bind("contextmenu", function() {
          return false;
        }); //为video添加禁止右键另存为操作
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    },
    checkChrome() {
      var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
      if (!isChrome) {
        this.isChrome = false;
      }
    },
  }
}
</script>


<style scoped lang="scss">
.mainPage {
	width: 100%;
	text-align: center;
	position: relative;
	min-height: 100%;
	// background-color: #ebf0f9;
	// background: linear-gradient(to right, #def3fd61, #ffdae23d);
	user-select: none;
  overflow: hidden;
  background: url('../img/chineseCultureVideoExhibition2025/m/content_bg.png') no-repeat center;

	.agentTip {
		width: 100%;
		height: 70px;
		line-height: 70px;
		background-color: #ffe6a1;
		text-align: center;
		position: absolute;
		z-index: 5;
		color: #c40000;
	}

	.agentTip .closeTip {
		position: absolute;
		right: 24px;
		top: 0px;
		font-size: 30px;
		color: #282828;
		cursor: pointer;
	}

	.header_banner {
		// position: relative;
		// background-image: url(../img/chineseCultureVideoExhibition/m_banner.png);
		// height: 285px;
		// background-size: cover;
		// background-repeat: no-repeat;
		// background-position: center;

		.imgBg {
			max-width: 100%;
			height: auto;
			position: absolute;
			z-index: -1;

			img {
				width: 100%;
			}
		}

		header {
			position: absolute;
			height: 50px;
			line-height: 50px;
			z-index: 2;
			// border-bottom: 1px solid rgba(#fff, 0.3);
			top: 0;
			width: 100%;
			margin: auto;
			color: #fff;

			.center {
				color: #8590cc;
				width: 90%;
				margin: auto;

				a {
					color: #8590cc;
					margin-right: 15px;
					// opacity: 0.8;
				}
			}

			.left {
				float: left;
			}

			.right {
				line-height: 50px;
				float: right;

				img {
					vertical-align: text-top;
					margin-right: 15px;
				}

				.loginCon {
					display: inline-block;
					margin-left: 30px;

					span {
						cursor: pointer;
					}

					.username {
						margin-right: 12px;
					}
				}
			}
		}

		.infoCon {

			.centerBg {
				width: 88%;
				margin: auto;

				img {
					margin-top: 25px;
					max-width: 97%;
					height: auto;
				}

			}
		}
	}

	.content {
		display: flex;
		flex-direction: row;
		justify-content: center;
		// max-width: 1400px;
		// height: 2860px;
		margin: auto;
		// margin-top: -125px;



		.leftBox {
			position: fixed;
			// width: 65%;
			top: 50px;
			right: 0px;
			background-color: #fff;
			border-radius: 5px 0 0 5px;
			box-shadow: -5px 5px 20px 0px #888888;
			text-align: end;
			z-index: 10000;

			.box {
				display: flex;
				flex-direction: column;
				margin-right: 30px;
				margin-left: 20px;
				margin-top: 20px;
				margin-bottom: 20px;
				// animation: my-animation1 0.5s ease-in-out;
				// @keyframes my-animation1 {
				// 	0% { transform: scale(.5); }
				// 	100% { transform: scale(1); }
				// }

				.titleBox {
					// padding: 7px 10px;
					display: flex;
					justify-content: flex-end;
					align-items: center;
					cursor: pointer;

					.title {
						padding: 7px 10px;
						display: flex;
						flex-direction: column;
						margin-right: 45px;

						.title_cn {
							font-size: 18px;
							line-height: 30px;
						}

						.title_en {
							font-size: 12px;
							font-family: DINCond-Medium;
						}

					}

					// .icon {
					// 	width: 30px;
					// 	height: 30px;
					// 	display: none;
					// }
				}

				.titleBox.active {
					.title {
						color: darkorange;
						margin-right: 45px;
					}

					// .icon {
					// 	display: block;
					// }
				}


			}

			.icon {
				position: absolute;
				bottom: 57px;
				right: 15px;
				width: 40px;
				height: 0px;

				img {
					width: 100%;
				}
			}

		}

		.icon1 {
			position: absolute;
			// bottom: 18px;
			top: 420px;
			right: 10px;
			width: 50px;
			height: 50px;
			z-index: 9999;

			// animation: my-animation 0.5s ease-in-out;
			// @keyframes my-animation {
			// 		0% { transform: scale(.5); }
			// 		100% { transform: scale(1); }
			// 	}
			img {
				width: 100%;
			}

		}



		.rightBox {
			width: 96%;
			display: flex;
			flex-direction: column;
			// text-align: left;

			.projectProfile {
				position: relative;
				margin-top: .5rem;
        padding: 0 .3rem;
				.box {
					margin: auto;
					margin-top: 10px;
					margin-bottom: 10px;
          padding: 0 .15rem;
          .name_cn {
            font-size: .6rem;
            font-weight: bold;
            color: #364347;
            text-align: left;
            margin-bottom: .1rem;
          }
          .name_en {
            font-size: .3rem;
            font-weight: bold;
            color: #93a4aa;
            text-align: left;
          }

					.text {
						font-size: .3rem;
						color: #5e696d;
						padding-top: 15px;
						line-height: 20px;
						text-align: justify;
						text-indent: 2em;
					}

					.text2 {
						font-size: .3rem;
						color: #5e696d;
						line-height: 20px;
						padding-bottom: 15px;
						text-align: justify;
					}
				}
			}

      .back_arrow {
        font-size: .8rem;
        color: #fff;
        cursor: pointer;
        margin-bottom: .3rem;
        text-align: left;
      }
      .page_con {
        background-color: #ffffff;
	      border-radius: .2rem;
        overflow: hidden;
      }
      .video_wrap {
        .cover_con {
          position: relative;
          cursor: pointer;
          .play_icon {
            position: absolute;
            left: .3rem;
            bottom: .3rem;
            width: 1rem;
          }
          .video_cover {
            display: block;
            width: 100%;
            height: 5.78rem;
            // border: solid 2px #e0ac68;
            margin-bottom: .4rem;
          }
        }
        .videoContainer {
          width: 10.28rem;
          height: 5.78rem;
          margin-bottom: .4rem;
          video {
            width: 100%;
            height: 100%;
          }
        }
        .video_list_wrap {
          overflow-x: auto;
          padding: 0 .3rem;
          .video_list {
            margin-bottom: .3rem;
            overflow: hidden;
            // width: max-content;
            li {
              width: 1rem;
              height: 1rem;
              float: left;
              margin-right: .15rem;
              margin-bottom: .2rem;
              border-radius: 0.14rem;
              background-image: linear-gradient(0deg, 
                rgba(231, 217, 206, 1) 0%, 
                #f8f4f1 100%);
              border: 1px solid rgba(186,159,125,1);
              font-size: .6rem;
              color: #a1896b;
              font-weight: bold;
              line-height: 1rem;
              text-align: center;
              cursor: pointer;
            }
          }
        }
        .link {
          width: max-content;
          height: 1.06rem;
          padding: 0 .3rem;
          margin-left: .3rem;
          box-sizing: border-box;
          border-radius: .15rem;
          background-image: linear-gradient(0deg, 
            rgba(231, 217, 206, 1) 0%, 
            #f8f4f1 100%);
          border: 1px solid rgba(186,159,125,1);
          display: flex;
          align-items: center;
          cursor: pointer;
          .link_icon {
            display: block;
            width: .6rem;
            margin-right: .15rem;
          }
          .name_con {
            color: #a1896b;
            font-weight: bold;
            text-align: left;
            .cn {
              font-size: .34rem;
            }
            .en {
              font-size: .3rem;
            }
          }
        }
        .link_con {
          display: flex;
          align-items: center;
          justify-content: center;
          .link {
            height: 1.06rem;
            float: left;
            padding: 0 .3rem;
            box-sizing: border-box;
            border-radius: .15rem;
            background-image: linear-gradient(0deg, 
              rgba(231, 217, 206, 1) 0%, 
              #f8f4f1 100%);
            border: 1px solid rgba(186,159,125,1);
            display: flex;
            align-items: center;
            cursor: pointer;
            &:nth-child(1) {
              margin-right: 23px;
            }
            .link_icon {
              margin-right: 15px;
            }
            .name_con {
              color: #a1896b;
              font-weight: bold;
              .cn {
                font-size: .34rem;
              }
              .en {
                font-size: .3rem;
              }
            }
          }
        }
      }

			.classBox {
				position: relative;
				background-color: #fff;
				margin-top: 1.2rem;
				border-radius: 12px 12px 12px 12px;

				.titleBox {
					width: auto;
					height: 1.2rem;
					position: absolute;
					z-index: 10;
					top: -0.8rem;
					left: -0.1rem;

					img {
						width: auto;
						height: 100%;
					}
				}

				.text {
					margin-top: 1.3rem;
					padding: 10px 15px 20px;
					text-align: justify;
				}

				.text_cn {
					font-size: .3rem;
					color: #5e696d;
					line-height: 24px;
					margin-top: 1.8rem;
					margin-bottom: 5px;
          text-align: left;
          text-indent: 2em;
				}

				.text_en {
					font-size: .3rem;
					color: #5e696d;
					line-height: 20px;
          text-align: left;
				}

        .info_left {
          width: max-content;
          overflow: hidden;
          margin-bottom: .2rem;
          .serise_icon_con {
            border: solid .03rem #ffffff;
            float: left;
            img {
              border-radius: 6px;
              width: 1.5rem;
              height: 1.5rem;
              display: block;
            }
          }
          .name_con {
            float: left;
            margin-top: .5rem;
            margin-left: .25rem;
            text-align: left;
            .cn {
              font-family: SourceHanSansCN;
              font-weight: bold;
              font-size: .6rem;
              color: #364347;
              margin-bottom: 4px;
            }
            .en {
              font-family: SourceHanSansCN;
              font-weight: bold;
              font-size: .3rem;
              color: #93a4aa;
            }
          }
        }

				.swiper_con {
					// margin-top: 25px;
					margin-left: 0rem;
					// margin-bottom: 40px;
					position: relative;

					.swiper-container {
						position: unset;
					}

					.swiper ::v-deep {
						.swiper-slide {
							// width: 7.2rem !important;

							.swiperBox {
								overflow: hidden;
							}
						}

						.video_con {
							width: 7.2rem;
              width: 10.28rem;

							.video_cover {
								width: 7.2rem;
								height: calc(7.2rem / (16/9));
                width: 10.28rem;
								height: calc(10.28rem / (16/9));
								background-color: #ffae00;
								// border-radius: .2rem;
								// border: solid .04rem #000000;
								// overflow: hidden;
								// margin-top: -.4rem;

								img {
									display: block;
									width: 100%;
									height: 100%;
									cursor: pointer;
								}

							}

							.playBtn {
								position: absolute;
								width: 0.8rem;
								height: 0.9rem;
								bottom: 1rem;
    						right: 0.4rem;
								z-index: 10;
								animation: my-animation 1.5s ease-in-out infinite;

								@keyframes my-animation {
									0% {
										transform: scale(.8);
									}

									50% {
										transform: scale(1);
									}

									100% {
										transform: scale(.8);
									}

								}

								img {}
							}

							.titleBox1 {
								position: absolute;
								height: 55px;
								margin-top: -55px;
								width: 100%;
								color: #fff;
								background-color: #55565775;
								text-align: left;
								bottom: 0;
								z-index: 100;
								display: flex;
    						align-items: center;

								.course_title {
									padding: 10px 20px;

									.cn {
										font-size: 16px;
									}

									.en {
										margin-top: 4px;
										font-size: 14px;
										// line-height: 12px;
									}
								}
							}

							// .title {
							// 	position: absolute;
							// 	width: 100%;
							// 	color: #000;
							// 	text-align: left;
							// 	z-index: 100;

							// 	.cn {
							// 		font-size: 16px;
							// 	}

							// 	.en {
							// 		margin-top: 4px;
							// 		font-size: 14px;
							// 	}
							// }
						}

						.video_con2 {
							width: 1rem;
							background-color: #c40000;

							.checkBox {
								width: 1rem;
								height: 1rem;
								background-color: #ffae00;

							}
						}
            .swiper-pagination {
              // position: relative;
            }
						.swiper-pagination-bullets {
							// height: 80px;
							// top: 4.2rem;
              bottom: -1.3rem;
							text-align: left;
							display: flex;
							flex-wrap: wrap;
							align-items: center;
							margin-left: 10px;

							.swiper-pagination-bullet-custom {
								// $size: 20px;
								border-radius: 0.14rem;
								border: 1px solid #ba9f7d;
								width: 1rem !important;
								height: 1rem !important;
								line-height: 1rem !important;
								text-align: center;
								color: #a1896b;
                background-image: linear-gradient(0deg, #e7d9ce 0%, #f8f4f1 100%);
								transition: all 0.5s;
								margin-right: 8px;
								margin-top: 4px;
                opacity: 1;

								// &:hover {
								// 	opacity: 0.8;
								// 	color: #eb7f66;
								// 	border: solid 1px #eb7f66;
								// 	background: rgba(#fceeeb, 0.6);
								// }

								&.swiper-pagination-bullet-active {
									opacity: 1;
									color: #eb7f66;
									border: solid 1px #eb7f66;
									background: rgba(#fceeeb, 0.6);
								}
							}

						}



					}

					.gallery-top {
						width: 7.2rem;
						height: calc(7.2rem / (16/9));
            width: 10.28rem;
						height: calc(10.28rem / (16/9));
						border-radius: 12px 12px 0 0;
					}

					.gallery-thumbs {
						height: 20%;
						box-sizing: border-box;
						// padding: 10px 0;
						width: 1rem;
					}

					.gallery-thumbs .swiper-slide {
						height: 100%;
						opacity: 0.4;
						width: 1rem !important;
					}

					.gallery-thumbs .swiper-slide-active {
						opacity: 1;
					}

					.swiper-button-prev {
						background-image: url(../img/chineseCultureVideoExhibition/prev.png);
						position: absolute;
						left: -75px;
						top: 90px;
					}

					.swiper-button-next {
						background-image: url(../img/chineseCultureVideoExhibition/next.png);
						right: -75px;
						top: 90px;
					}


				}

        .series_type2_con {
          overflow: hidden;
          margin-top: 15px;
          .cover_con {
            width: 10.28rem;
	          height: 5.8rem;
            display: block;
            margin-right: 22px;
          }
          .cover {
            display: block;
            width: 100%;
            height: 100%;
          }
          .des_con {
            font-size: .3rem;
            color: #5e696d;
            line-height: 1.6;
            text-align: left;
            margin-top: .5rem;
            .cn {
              text-indent: 2em;
              margin-bottom: .2rem;
              display: -webkit-box;             /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 4;            /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden;                 /* 隐藏超出的内容 */
            }
            .en {
              display: -webkit-box;             /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical;     /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 5;            /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden;                 /* 隐藏超出的内容 */
            }
          }
        }

			}
		}
	}

	.footer {
		margin-top: 1rem;
		margin-bottom: .8rem;
    font-size: .24rem;
		.copy {
			// position: absolute;
			// bottom: 70px;
			width: 100%;
			text-align: center;
			font-weight: 600;
		}

		img {
			width: 100%;
		}
	}



	#videoPlayWrapper {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.88);
		z-index: 9999;
	}

	#menuGuide {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 9999;
	}

	#videoPlayWrapper .closeVideo {
		position: absolute;
		right: 20px;
		top: 10px;
		font-size: 50px;
		color: #fff;
		cursor: pointer;
	}

	.videoContent {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.videoContainer {
		text-align: center;
		width: 100%;
	}

	.videoContainer video {
		width: 100%;
	}

	video::-internal-media-controls-download-button {
		display: none;
	}

	video::-webkit-media-controls-enclosure {
		overflow: hidden;
	}

	video::-webkit-media-controls-panel {
		width: calc(100% + 30px);
	}
}

</style>
